import React, {lazy, Suspense, useEffect} from "react";
import {Globals} from "../controllers/Globals";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {Menu} from "./commond/Menu";
import {TopBar} from "./commond/topBar/TopBar";
import {MenuMobile} from "./commond/MenuMobile";
import {SocketManager} from "../controllers/SocketManager";
import {log} from "../../cuppa/cuppa";
import {CuppaPortal} from "../../cuppa/reactComponents/CuppaPortal";
import {ConversationsCtrl} from "../controllers/ConversationsCtrl";
import {CuppaStorage} from "../../cuppa/cuppa.storage";
import {Storages} from "../controllers/Storages";

const Home = lazy(() => import('../components/home/Home'));
const Conversations = lazy(() => import("../components/conversations/Conversations"));
const Conversation = lazy(() => import("../components/conversations/conversation/Conversation"));
const Questions = lazy(() => import("../components/questions/Questions"));
const Question = lazy(() => import("../components/questions/question/Question"));
const Users = lazy(() => import("./users/Users"));
const User = lazy(() => import("./users/user/User"));
const Organizations = lazy(() => import("./organizations/Organizations"));
const Organization = lazy(() => import("./organizations/organization/Organization"));
const LinkedOrganizations = lazy(() => import("./organizations/linkedOrganizations/LinkedOrganizations"));
const LinkedQuestions = lazy(() => import("./organizations/linkedOrganizations/linkedQuestions/LinkedQuestions"));

export function App(){
	useEffect(()=>{
		SocketManager.connect().then();
		ConversationsCtrl.getEarlierConversationDate().then(date=>CuppaStorage.setDataSync({...Storages.earlierConversationDate, data:date}));
		let unListen = Globals.router.history.listen(onURLChange);
		return ()=>{ unListen(); }
	}, [])

	function onURLChange(){
		document.defaultView.scrollTo(0,0);
	}

	return (
		<Router ref={(ref)=>{ Globals.router = ref }}  >
			<Menu className={'d-none-s1100'} />
			<MenuMobile />
			<TopBar />
			<div className={'main-content | m-l-0-s1100 p-l-10-s1100 p-r-10-s1100 p-t-70-s1100'} style={{display:'flex', marginLeft:'var(--menu-width)', padding:20, paddingTop:'calc(var(--top-bar-height) + 2rem)', flexDirection:"column"}}>
				<Suspense fallback={null} >
					<Switch>
						<Route path="/" exact={true} ><Home /></Route>
						<Route path="/conversations/conversation/*" ><Conversation /></Route>
						<Route path={'/conversations/*'} exact={true} ><Conversations /></Route>
						<Route path="/users/user/*" ><User /></Route>
						<Route path="/users/"  ><Users /></Route>
						<Route path="/questions/question/*" ><Question /></Route>
						<Route path="/questions/"  ><Questions /></Route>
						<Route path="/organizations/organization/*" ><Organization /></Route>
						<Route path="/organizations/linked-community/:organizationLinkId/questions/" ><LinkedQuestions /></Route>
						<Route path="/organizations/linked/*" ><LinkedOrganizations /></Route>
						<Route path="/organizations/" ><Organizations /></Route>
					</Switch>
				</Suspense>
			</div>
			<div className={'fixed flex d-column nowrap j-start a-r-t z-index-9999 p-x-10 p-y-10 o-auto hide-scroll'} style={{maxHeight:'100vh'}} >
				<CuppaPortal ref={ ref =>{ if(!ref) return; Globals.notificationPortal = ref } } />
			</div>
		</Router>
	)
}
